import { useState } from 'react';

let order = ["C", "C#", "D", "Eb", "E", "F", "F#", "G", "Ab", "A", "Bb", "B"];

let table = [["?", "?", "?", "?", "?", "?", "?", "?", "?", "?", "?", "?"],
["?", "?", "?", "?", "?", "?", "?", "?", "?", "?", "?", "?"],
["?", "?", "?", "?", "?", "?", "?", "?", "?", "?", "?", "?"]];

function breakDown(str) {
  const lastChar = str.slice(-1);
  switch (lastChar) {
    case "m":
      str = str.slice(0, -1);
      return (str + " - " + order[(order.indexOf(str) + 3) % 12] + " - " + order[(order.indexOf(str) + 7) % 12]);
    case "˚":
      str = str.slice(0, -1);
      return (str + " - " + order[(order.indexOf(str) + 3) % 12] + " - " + order[(order.indexOf(str) + 6) % 12]);
    default:
      return (str + " - " + order[(order.indexOf(str) + 4) % 12] + " - " + order[(order.indexOf(str) + 7) % 12]);
  }
}

function conv(message) {
  const words = message.split(" ");
  const targetIndexes = [9, 4, 11, 6, 1, 8, 3, 10, 5, 0, 7, 2];
  let notes = targetIndexes.map(index => order[index]);
  let index = notes.indexOf(words[0]);
  if (words[1] === "min") {
    for (let i = 0; i < 12; i++) {
      table[0][i] = notes[(index + i + 8) % 12] + "˚";
    }
    for (let i = 0; i < 12; i++) {
      table[1][i] = notes[(index + i + 6) % 12] + "m";
    }
    for (let i = 0; i < 12; i++) {
      table[2][i] = notes[(index + i + 3) % 12];
    }
  }
  else {
    for (let i = 0; i < 12; i++) {
      table[0][i] = notes[(index + i + 11) % 12] + "˚";
    }
    for (let i = 0; i < 12; i++) {
      table[1][i] = notes[(index + i + 9) % 12] + "m";
    }
    for (let i = 0; i < 12; i++) {
      table[2][i] = notes[(index + i + 6) % 12];
    }
  }
  return table;
}

function Form({ onCreate }) {
  const [selectedKey, setSelectedKey] = useState('');
  const [selectedScale, setSelectedScale] = useState('');

  function handleClick() {
    let message = selectedKey + " " + selectedScale;
    table = conv(message);
    onCreate(message);
  }

  return (
    <form className='forma'>
      <label htmlFor="key">
        Key:
        <select
          id="key"
          value={selectedKey}
          onChange={e => setSelectedKey(e.target.value)}
        >
          <option selected></option>
          <option value="A">A</option>
          <option value="A#">A#</option>
          <option value="B">B</option>
          <option value="C">C</option>
          <option value="C#">C#</option>
          <option value="D">D</option>
          <option value="D#">D#</option>
          <option value="E">E</option>
          <option value="F">F</option>
          <option value="F#">F#</option>
          <option value="G">G</option>
          <option value="G#">G#</option>
        </select>
      </label>

      <label htmlFor="scale">
        Scale:
        <select
          id="scale"
          value={selectedScale}
          onChange={e => setSelectedScale(e.target.value)}
        >
          <option selected></option>
          <option value="min">min</option>
          <option value="maj">maj</option>
        </select>
      </label>

      <button type="button" onClick={handleClick}>
        Create
      </button>
    </form>
  );
}

export default function Screen() {
  const [message, setMessage] = useState('');
  const [hoveredNote, setHoveredNote] = useState('');

  return (
    <>
      <Form onCreate={setMessage} />
      <div className="hover-display">
        {hoveredNote ? breakDown(hoveredNote) : 'Hover over a chord'}
      </div>
      <div className="circle-wrapper">
        <div className="circle">
          {table[0].map((note, index) => {
            const angle = index * 30 - 90;

            return (
              <div
                key={`outer-${index}`}
                className="note outer"
                style={{
                  transform: `rotate(${180 + angle}deg) translate(calc(var(--circle-size) * 0.43)) rotate(${180 - angle}deg)`
                }}
                onMouseEnter={() => setHoveredNote(note)}
                onMouseLeave={() => setHoveredNote('')}
              >
                {note}
              </div>
            );
          })}

          {table[1].map((note, index) => {
            const angle = index * 30 - 90;

            return (
              <div
                key={`middle-${index}`}
                className="note middle"
                style={{
                  transform: `rotate(${180 + angle}deg) translate(calc(var(--circle-size) * 0.29)) rotate(${180 - angle}deg)`
                }}
                onMouseEnter={() => setHoveredNote(note)}
                onMouseLeave={() => setHoveredNote('')}
              >
                {note}
              </div>
            );
          })}

          {table[2].map((note, index) => {
            const angle = index * 30 - 90;

            return (
              <div
                key={`inner-${index}`}
                className="note inner"
                style={{
                  transform: `rotate(${180 + angle}deg) translate(calc(var(--circle-size) * 0.18)) rotate(${180 - angle}deg)`
                }}
                onMouseEnter={() => setHoveredNote(note)}
                onMouseLeave={() => setHoveredNote('')}
              >
                {note}
              </div>
            );
          })}

          <div className="hole">{message}</div>
        </div>
      </div>
    </>

  );
}